import React from 'react';
import { Grid } from '@mui/material';
import { Body1, H1, Subtitle1 } from '../../../components/typography';
import { PrimaryButton } from '../../../components/buttons';
import { useTranslation } from 'react-i18next';

interface Props {
    setIsOpen: (value: boolean) => void,
    rowCount: number
}

const Header:React.FC<Props> = ({
  setIsOpen,
  rowCount
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid size={8}>
          <H1>{t('Reservations')}</H1>
          <Subtitle1>{t('List of reservations:') + ' ' + rowCount}</Subtitle1>
        </Grid>
        <Grid size={4}>
          <Body1 align='right'>
            <PrimaryButton onClick={() => setIsOpen(true)}>{t('Add Reservation')}</PrimaryButton>
          </Body1>
        </Grid>
      </Grid>
    </>
  );
};

export default Header;
